/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Models_Save_SuccessInputs */



/**
* | output |
* | --- |
* | "Team model configuration updated successfully." |
*
* @param {Team_Models_Save_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const team_models_save_success = /** @type {((inputs?: Team_Models_Save_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Models_Save_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Team-Modellkonfiguration erfolgreich aktualisiert.")
	return /** @type {LocalizedString} */ ("Team model configuration updated successfully.")
});